// extracted by mini-css-extract-plugin
module.exports = {"root":"ShelfGroup_root__OG3gP"};